"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.RulesEngine = exports.instance = void 0;

var lodash_1 = __importDefault(require("lodash"));

var Response_1 = require("./Response");

var Rule_1 = require("./Rule");

var Token_1 = require("./Token");

var Terms_1 = require("./Terms");

var lookup_1 = require("./Terms/lookup");

var Validator_1 = __importDefault(require("./Validator"));

var Packages_1 = require("./Packages");

var RulesEngine = function () {
  function RulesEngine() {
    this.data = {};
    this.rulesMap = {};
    this.maxIterations = 10;
    this.packages = new Packages_1.Packages(this);
    this.useInversions = true;
  }

  RulesEngine.prototype.init = function (opts, middleware) {
    var _a;

    if (opts === void 0) {
      opts = {};
    }

    this.data = {
      attributes: this.getAttributes(opts),
      properties: this.getProperties(opts),
      packages: this.getPackages(opts),
      rules: (_a = opts.rules) === null || _a === void 0 ? void 0 : _a.map(function (rule) {
        return new Rule_1.Rule(rule);
      })
    };
    this.rulesMap = this.createRulesMap(this.data.rules);

    if (opts.useInversion) {
      this.useInversions = true;
    }

    if (opts.maxIterations) {
      this.maxIterations = opts.maxIterations;
    }

    if (opts.validate) {
      this.validator = new Validator_1["default"]({
        attributes: this.data.attributes,
        properties: this.data.properties,
        packages: this.data.packages
      });
    }

    this.middleware = middleware;
  };

  RulesEngine.prototype.createRulesMap = function (rules) {
    var _this = this;

    if (rules === void 0) {
      rules = [];
    }

    var rulesMap = {};
    var namingSchema = this.getModelNames();

    if (lodash_1["default"].isObject(rules)) {
      var arr = lodash_1["default"].values(rules);
      rules = lodash_1["default"].flatten(arr);
    }

    rulesMap.Falsy = [];
    rules.forEach(function (rule) {
      if (_this.validator) {
        var resp = _this.validator.run(rule.orig);

        if (!resp.valid) {
          console.warn(resp);
          return;
        }
      }

      var ids = rule.tokens.filter(function (t) {
        return t.token === Terms_1.Id.token;
      });
      ids.forEach(function (id) {
        if (!id.value) {
          return;
        }

        var value = id.value;
        id.data.collection = namingSchema.collections.property;

        if (lodash_1["default"].includes(lodash_1["default"].get(_this.data.attributes, 'allIds', []), value)) {
          id.data.collection = namingSchema.collections.attribute;
        }

        if (!rulesMap[value]) {
          rulesMap[value] = [];
        }

        rulesMap[value].push(rule);

        if (id.Falsy) {
          rulesMap.Falsy.push(rule);
        }
      });
    });
    return rulesMap;
  };

  RulesEngine.prototype.run = function (configuration, selection, debug) {
    if (debug === void 0) {
      debug = false;
    }

    var resp = new Response_1.Response(this, {
      debug: debug
    });

    try {
      resp.before = configuration;
      resp.selection = lodash_1["default"].clone(selection);
      var newConfiguration = this.initialApply(selection, configuration, resp);

      while (resp.diffs.length < this.maxIterations) {
        var before = lodash_1["default"].assign({}, newConfiguration);
        this.runOnce(newConfiguration, resp);
        var diff = resp.diff(before, newConfiguration);

        if (lodash_1["default"].isEmpty(diff)) {
          break;
        }
      }

      this.clean(newConfiguration);
      resp.after = newConfiguration;
      return resp.finish();
    } catch (e) {
      console.error('There was an error running the RulesEngine', e);
      return resp.finish();
    }
  };

  RulesEngine.prototype.runOnce = function (configuration, resp) {
    var _this = this;

    var rules = this.getApplicableRules(configuration);
    rules.forEach(function (rule) {
      try {
        _this.applyRule(rule, configuration, resp);
      } catch (e) {
        console.error("Error running rule " + rule.orig + ". Skipping...", e);
      }
    });
  };

  RulesEngine.prototype.initialApply = function (selection, configuration, resp) {
    var newConfiguration = Object.assign({}, configuration);
    this.applyPackages(selection, newConfiguration, resp);
    lodash_1["default"].assign(newConfiguration, selection);
    resp.diff(resp.before, newConfiguration);
    return newConfiguration;
  };

  RulesEngine.prototype.getApplicableRules = function (configuration) {
    var _this = this;

    var applicable = [];
    var configurationIds = lodash_1["default"].keys(configuration).concat(lodash_1["default"].uniq(lodash_1["default"].values(configuration)));
    configurationIds.forEach(function (id) {
      var rules = _this.rulesMap[id];

      if (rules) {
        applicable = lodash_1["default"].union(applicable, rules);
      }
    });
    applicable = lodash_1["default"].union(applicable, this.rulesMap.Falsy);
    return applicable;
  };

  RulesEngine.prototype.applyInversion = function (rule, configuration, resp) {
    var condition = rule.getCondition();
    var conditionIds = lodash_1["default"].filter(condition, function (c) {
      return c.token === Terms_1.Id.token;
    });
    var result = rule.getResult();
    var newResult = [];
    var newCondition = result.filter(function (token) {
      if (token.token === Terms_1.Force.token) {
        newResult.push(token);
        return false;
      }

      return true;
    });
    conditionIds.forEach(function (c) {
      c.Falsy = !(c.Falsy === true);
      newResult.push(c);

      if (c !== lodash_1["default"].last(conditionIds)) {
        newResult.push(new Token_1.Token(Terms_1.And));
      }
    });
    resp.inversions.push("if " + Token_1.Token.mash(newCondition) + " then " + Token_1.Token.mash(newResult));
    return result;
  };

  RulesEngine.prototype.applyOverrides = function (data, overrides) {
    overrides.forEach(function (override) {
      var collection = override.collection,
          id = override.id,
          property = override.property,
          value = override.value;

      try {
        data[collection].byId[id][property] = value;
      } catch (e) {
        console.warn("Error applying override '" + property + ": " + value + "' to " + collection);
      }
    });
    return data;
  };

  RulesEngine.prototype.applyPackages = function (selection, configuration, resp) {
    var _this = this;

    var selectedAttributes = lodash_1["default"].keys(selection);
    var namingSchema = this.getModelNames();
    selectedAttributes.forEach(function (attr) {
      var prop = selection[attr];

      if (!lodash_1["default"].isNil(prop)) {
        var matchingPackages_1 = _this.packages.getMatchingPackages(selection, _this.data.packages);

        lodash_1["default"].keys(matchingPackages_1).forEach(function (pkgId) {
          var applicablePackages = matchingPackages_1[pkgId];

          if (lodash_1["default"].isEmpty(applicablePackages)) {
            return;
          }

          if (applicablePackages.length === 1) {
            _this.packages.applyPackage(applicablePackages[0], configuration, selection, resp);

            return;
          }

          var options = applicablePackages.map(function (pkgOptionId) {
            return {
              action: 'add',
              collection: namingSchema.collections.property,
              id: pkgOptionId
            };
          });
          resp.log.add(new Token_1.Token(Terms_1.Or), {
            or: options
          });
        });
        return;
      }

      var deletedProperty = resp.before[attr];
      var reverseSelection = {};
      reverseSelection[attr] = deletedProperty;

      var matchingPackages = _this.packages.getMatchingPackages(reverseSelection, _this.data.packages);

      lodash_1["default"].keys(matchingPackages).forEach(function (pkgId) {
        var applicablePackages = matchingPackages[pkgId];

        if (lodash_1["default"].isEmpty(applicablePackages)) {
          return;
        }

        _this.packages.removePackages(applicablePackages, configuration, reverseSelection, resp);
      });
    });
  };

  RulesEngine.prototype.applyResult = function (rule, configuration, resp) {
    var result = rule.getResult();
    var initialSelection = resp.getSelection();
    var namingSchema = this.getModelNames();

    if (this.useInversions) {
      var interrupt = this.evaluateSelection(initialSelection, rule);

      if (interrupt) {
        return;
      }
    }

    this.evaluateOrResult(rule, result, configuration, resp);

    for (var i = 0; i < result.length; i++) {
      var t = result[i];

      if (t.evaluated) {
        continue;
      }

      switch (t.token) {
        case Terms_1.Id.token:
          {
            if (lodash_1["default"].includes(this.data.attributes.allIds, t.value)) {
              var attribute_1 = this.data.attributes.byId[t.value];
              var defaultPropertyId = this.getDefaultPropertyId(attribute_1);

              if (!defaultPropertyId) {
                console.warn("No defaultPropertyId found for attribute " + t.value + " in rule '" + rule.orig + "'. Skipping...");
                continue;
              }

              if (t.Falsy) {
                if (t.Force && configuration[t.value]) {
                  resp.log.add(t, Terms_1.Force.log({
                    action: 'remove',
                    collection: namingSchema.collections.attribute
                  }));
                }

                delete configuration[t.value];
                continue;
              }

              if (!configuration[t.value]) {
                if (t.Force) {
                  resp.log.add(t, Terms_1.Force.log({
                    action: 'add',
                    collection: namingSchema.collections.attribute
                  }));
                }

                configuration[t.value] = defaultPropertyId;
              }

              continue;
            }

            var property = this.data.properties.byId[t.value];

            if (!property) {
              console.warn("Property not found for id '" + t.value + "' in rule '" + rule.orig + "'. Skipping...");
              continue;
            }

            var attribute = this.getParentAttribute(property);

            if (t.Falsy) {
              if (t.Force && configuration[attribute] === t.value) {
                resp.log.add(t, Terms_1.Force.log({
                  action: 'remove',
                  collection: namingSchema.collections.property
                }));
              }

              delete configuration[attribute];
              continue;
            }

            if (configuration[attribute] !== t.value) {
              if (t.Force) {
                if (configuration[attribute]) {
                  resp.log.add(configuration[attribute], Terms_1.Force.log({
                    action: 'remove',
                    collection: namingSchema.collections.property
                  }));
                }

                resp.log.add(t, Terms_1.Force.log({
                  action: 'add',
                  collection: namingSchema.collections.property
                }));
              }

              configuration[attribute] = t.value;
            }

            break;
          }

        case Terms_1.Force.token:
        case Terms_1.Not.token:
        case Terms_1.Falsy.token:
        case Terms_1.Or.token:
        case Terms_1.And.token:
          break;

        default:
          var term = lookup_1.lookup.byValue(t.value);

          if (term && term.opts.override) {
            var override = term.override(result.slice(i));
            var skip = override._length;
            delete override._length;
            resp.overrides.push(override);
            i += skip;
          }

      }
    }
  };

  RulesEngine.prototype.applyRule = function (rule, configuration, resp) {
    var ruleApplies = this.evaluateCondition(rule, configuration, resp.selection);

    if (!ruleApplies) {
      return;
    }

    if (resp.debug) {
      resp.rules = lodash_1["default"].union(resp.rules, [rule]);
    }

    this.applyResult(rule, configuration, resp);
  };

  RulesEngine.prototype.evaluateCondition = function (rule, configuration, selection) {
    if (selection === void 0) {
      selection = {};
    }

    var condition = rule.getCondition();
    this.evaluateFalsies(condition, configuration);
    this.evaluateIDs(condition, configuration, selection);
    this.evaluateGroups(condition, configuration, rule);
    return !lodash_1["default"].includes(condition, false);
  };

  RulesEngine.prototype.evaluateIDs = function (tokens, configuration, selection) {
    if (selection === void 0) {
      selection = {};
    }

    tokens.forEach(function (t) {
      if (!(t instanceof Token_1.Token)) {
        return;
      }

      if (t.token === Terms_1.Selection.token) {
        var selectionIndex = lodash_1["default"].findIndex(tokens, ['index', t.index]);
        var idToken = tokens[selectionIndex + 1];

        if (idToken instanceof Token_1.Token) {
          var value = idToken.value;

          if (lodash_1["default"].keys(selection).indexOf(value) > -1 || lodash_1["default"].values(selection).indexOf(value) > -1) {
            var res = Terms_1.Id.evaluate([idToken], configuration);
            tokens.splice(selectionIndex, 2, res);
            return;
          }
        }

        tokens.splice(selectionIndex, 2, false);
      }

      if (t.token === Terms_1.Id.token) {
        var idIndex = lodash_1["default"].findIndex(tokens, ['index', t.index]);
        var res = Terms_1.Id.evaluate([t], configuration);
        tokens.splice(idIndex, 1, res);
      }
    });
  };

  RulesEngine.prototype.evaluateFalsies = function (tokens, configuration) {
    var falsies = lodash_1["default"].filter(tokens, function (t) {
      return t instanceof Token_1.Token && t.Falsy;
    });
    falsies.forEach(function (t) {
      if (!(t instanceof Token_1.Token)) {
        return;
      }

      var falsyIndex = lodash_1["default"].findIndex(tokens, ['index', t.index]) - 1;
      var falsyGroup = [tokens[falsyIndex], tokens[falsyIndex + 1]];
      var res = Terms_1.Falsy.evaluate(falsyGroup, configuration);
      tokens.splice(falsyIndex, 2, undefined, res);
    });
  };

  RulesEngine.prototype.evaluateGroups = function (tokens, configuration, rule) {
    var groupOpens = lodash_1["default"].reverse(lodash_1["default"].filter(tokens, function (t) {
      return t instanceof Token_1.Token && t.token === Terms_1.GroupOpen.token;
    }));
    var andOrs = lodash_1["default"].filter(tokens, function (t) {
      return t instanceof Token_1.Token && lodash_1["default"].includes([Terms_1.And.token, Terms_1.Or.token], t.token);
    });
    var groups = lodash_1["default"].concat(groupOpens, andOrs);
    groups.map(function (token) {
      var tokenIndex = lodash_1["default"].findIndex(tokens, ['index', token.index]);

      if (token.evaluated || tokenIndex > tokens.length) {
        return;
      }

      if (tokenIndex === -1) {
        console.warn(token, tokens);
        return;
      }

      var isGroup = token.token === Terms_1.GroupOpen.token;
      var group = isGroup ? Rule_1.Rule.getGroupAt(tokenIndex, tokens) : Rule_1.Rule.getClauseAt(tokenIndex, tokens);
      var results = [];
      group.map(function (t) {
        if (t instanceof Token_1.Token) {
          switch (t.token) {
            case Terms_1.And.token:
              {
                var res = Terms_1.And.evaluate(group, configuration);
                t.evaluated = true;
                results.push(res);
                break;
              }

            case Terms_1.Or.token:
              {
                var res = Terms_1.Or.evaluate(group, configuration);
                t.evaluated = true;
                results.push(res);
                break;
              }
          }
        }
      });
      var groupResult = !results.includes(false);
      var groupStartIndex = isGroup ? lodash_1["default"].findIndex(tokens, ['index', token.index]) : lodash_1["default"].findIndex(tokens, ['index', token.index]) - 1;
      var groupLength = isGroup ? group.length + 2 : group.length;
      tokens.splice(groupStartIndex, groupLength, groupResult);
    });
  };

  RulesEngine.prototype.evaluateOrResult = function (rule, result, configuration, resp) {
    var _this = this;

    var namingSchema = this.getModelNames();
    result.forEach(function (token, index) {
      if (token.token === Terms_1.Or.token && !token.evaluated) {
        var orClause = Rule_1.Rule.getClauseAt(index, result);
        var orResult = Terms_1.Or.evaluate(orClause, configuration);
        orClause.forEach(function (t) {
          if (t instanceof Token_1.Token) t.evaluated = true;
        });

        if (!orResult) {
          var options = [];

          for (var i = 0; i < orClause.length; i++) {
            var t = orClause[i];

            if (!(t instanceof Token_1.Token)) {
              continue;
            }

            switch (t.token) {
              case Terms_1.Id.token:
                {
                  if (lodash_1["default"].includes(_this.data.attributes.allIds, t.value)) {
                    continue;
                  }

                  if (t.Falsy) {
                    options.push({
                      action: 'remove',
                      collection: namingSchema.collections.property,
                      id: t.value
                    });
                    continue;
                  }

                  options.push({
                    action: 'add',
                    collection: namingSchema.collections.property,
                    id: t.value
                  });
                  break;
                }

              default:
            }
          }

          resp.log.add(token, {
            or: options,
            ruleId: rule.id
          });
        }
      }
    });
  };

  RulesEngine.prototype.evaluateSelection = function (selection, rule) {
    var selectedAttributes = lodash_1["default"].keys(selection);
    var selectedProperties = lodash_1["default"].values(selection);
    var modelNames = this.getModelNames();
    var result = rule.getResult();
    var resultIds = lodash_1["default"].filter(result, function (t) {
      return t instanceof Token_1.Token && t.token === Terms_1.Id.token && !t.Modifier;
    });
    var orIds = lodash_1["default"].filter(lodash_1["default"].flatten(result.map(function (t, i) {
      if (t instanceof Token_1.Token && t.token === Terms_1.Or.token) {
        return Rule_1.Rule.getClauseAt(i, result).filter(function (t) {
          return t instanceof Token_1.Token && t.token == Terms_1.Id.token;
        }).map(function (t) {
          return t.value;
        });
      }
    })), function (t) {
      return !lodash_1["default"].isNil(t);
    });

    for (var i = 0; i < resultIds.length; i++) {
      var id = resultIds[i];

      if (id.data.collection === modelNames.collections.attribute) {
        if (lodash_1["default"].includes(selectedAttributes, id.value) && id.Falsy) {
          return true;
        }
      }

      if (id.data.collection === modelNames.collections.property) {
        var property = this.data.properties.byId[id.value];
        var parentAttribute = this.getParentAttribute(property);

        if (lodash_1["default"].includes(selectedAttributes, parentAttribute)) {
          if (!lodash_1["default"].includes(selectedProperties, id.value) && !id.Falsy) {
            if (!lodash_1["default"].includes(orIds, id.value)) return true;
          }
        }
      }
    }

    return false;
  };

  RulesEngine.prototype.getBaseConfiguration = function (withRules) {
    var _this = this;

    if (withRules === void 0) {
      withRules = true;
    }

    var configuration = {};
    var attributes = lodash_1["default"].values(lodash_1["default"].get(this.data.attributes, 'byId', {}));
    attributes.forEach(function (attr) {
      if (!_this.getIsDefault(attr)) {
        return;
      }

      var defaultPropertyId = _this.getDefaultPropertyId(attr);

      if (defaultPropertyId) {
        var id = _this.getId(attr);

        configuration[id] = defaultPropertyId;
      }
    });

    if (!withRules) {
      return configuration;
    }

    var resp = this.run(configuration, {});
    return resp;
  };

  RulesEngine.prototype.getModelNames = function () {
    return {
      collections: {
        attribute: 'attributes',
        property: 'properties'
      }
    };
  };

  RulesEngine.prototype.getAttributes = function (data) {
    return data === null || data === void 0 ? void 0 : data.attributes;
  };

  RulesEngine.prototype.getIsDefault = function (doc) {
    return doc["default"];
  };

  RulesEngine.prototype.getIsRequired = function (doc) {
    return doc.required;
  };

  RulesEngine.prototype.getDefaultPropertyId = function (attribute) {
    return attribute.defaultProperty;
  };

  RulesEngine.prototype.getId = function (doc) {
    return doc.id;
  };

  RulesEngine.prototype.getPackages = function (data) {
    var _a;

    return ((_a = this.packages) === null || _a === void 0 ? void 0 : _a.parsePackages(data)) || {};
  };

  RulesEngine.prototype.getParentAttribute = function (doc) {
    return doc.attributeId;
  };

  RulesEngine.prototype.getProperties = function (data) {
    return data === null || data === void 0 ? void 0 : data.properties;
  };

  RulesEngine.prototype.clean = function (configuration) {
    var _this = this;

    lodash_1["default"].keys(configuration).forEach(function (key) {
      if (lodash_1["default"].isNil(configuration[key])) {
        delete configuration[key];
      }
    });
    var attributes = lodash_1["default"].values(this.data.attributes.byId).filter(function (a) {
      return _this.getIsRequired(a);
    });
    attributes.forEach(function (a) {
      var defaultProperty = _this.getDefaultPropertyId(a);

      var id = _this.getId(a);

      if (defaultProperty) {
        if (lodash_1["default"].isNil(configuration[id])) {
          configuration[id] = defaultProperty;
        }
      }
    });
  };

  return RulesEngine;
}();

exports.RulesEngine = RulesEngine;
var instance = new RulesEngine();
exports.instance = instance;